import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../redux/reducers/root";
import { RouteProps, useHistory } from "react-router-dom";

interface Props extends RouteProps {}

const Notification: React.FC<Props> = () => {
  document.title = "پیام ها و اعلانات - پنل دستیار پزشک خوب";

  const history = useHistory();
  const selectedDoctor = useSelector((state: State) => state.selectDoctor);
  const notificationList = useSelector((state: State) => state.notification);

  return (
    <>
      {notificationList.status === "LOADING" ? (
        <div className="flex items-center justify-center mt-[28px]">
          در حال بارگذاری
          <i className="flex items-center mr-1 fa fa-spinner animate-spin "></i>
        </div>
      ) : (
        <div className="flex flex-col pb-3">
          <div className="p-4 mx-3 mt-3 mb-0 bg-white rounded-t-lg">
            <div className="flex items-center gap-3">
              <i className="far fa-bell fa-lg"></i>
              <div className="font-bold">پیام‌ها و اعلانات</div>
            </div>
          </div>

          <div className="mx-3 shadow-pkc-xl">
            {notificationList.data?.map(
              (notification, index) =>
                index > 0 &&
                "id" in notification && (
                  <div
                    key={notification.id}
                    className={`flex flex-col p-4 mt-[1px] bg-white cursor-pointer hover:bg-gray-100 ${
                      !notification.seen && "border-pkc-primary border-solid border-r-3"
                    }`}
                    onClick={() => history.push(`/doctors/${selectedDoctor.id}/notification/${notification.id}`)}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <i className={`far ${notification.seen ? "fa-envelope-open" : "fa-envelope"} fa-lg`}></i>
                        <div className="text-xs font-semibold">{notification.notification.title}</div>
                      </div>
                      <div className="text-xs text-gray-300">مشاهده</div>
                    </div>
                    <div className="mt-2 overflow-hidden text-xs whitespace-nowrap overflow-ellipsis">
                      {notification.notification.message}
                    </div>
                  </div>
                )
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default Notification;
